import React from 'react'
import { NavLink } from 'react-router-dom'
import '../App.css'
import Logo from 'url:../assets/images/logo.png'

export const Header = () => {
  return (
    <header>
      {/* Top bar — contact strip */}
      <div className="topbar">
        <div className="topbar-inner">
          <span className="topbar-item">
            <i className="fa-solid fa-phone"></i>
            +91 80589 24298
          </span>
          <span className="topbar-item">
            <i className="fa-solid fa-envelope"></i>
            support@gaurangengineering.co.in
          </span>
        </div>
      </div>

      {/* Main header — logo + nav */}
      <div className="main-header">
        <div className="main-header-inner">
          <img src={Logo} className="logo" alt="Gaurang Engineering" />
          <nav>
            <ul className="nav-menu">
              <li>
                <NavLink to="/" end className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                  Home
                </NavLink>
              </li>
              {/* <li><NavLink to="/services" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Services</NavLink></li>
              <li><NavLink to="/projects" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Projects</NavLink></li>
              <li><NavLink to="/industries" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Industries</NavLink></li>
              <li><NavLink to="/about" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>About</NavLink></li> */}
              <li>
                <NavLink to="/contact" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  )
}
